import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatDialog } from '@angular/material/dialog';
import { DummyComponent } from '../../../shared/dummy.component';
import * as FileSaver from 'file-saver';
import { consts } from '../../../consts';
import { Utils } from '../../../shared/utils';
import { FinanciacionPrivadaService } from './financiacion-privada.service';
import { FinanciacionPrivadaConst } from './financiacion-privada-const';
import { FinanciacionPrivadaModel } from './financiacion-privada.model';
import { FinanciacionPrivadaDialogDeleteComponent } from './financiacion-privada-dialog-delete.component';
import { FinanciacionPrivadaDialogAttachmentComponent } from './financiacion-privada-dialog-attachment.component';
import { FinanciacionPrivadaDialogPagoCuotasComponent } from './financiacion-privada-dialog-pago-cuotas.component';
import { FinanciacionPrivadaDialogDeudaACortoPlazoComponent } from './financiacion-privada-dialog-deuda-a-corto-plazo.component';
import { FinanciacionPrivadaDialogConstitucionComponent } from './financiacion-privada-dialog-constitucion.component';
import { AccountingManualFormComponent } from '../../accounting/manual/accounting-manual-form.component';
import { TableService } from '../../../shared/components/table/table.service';

@Component({
    selector: 'convfact-financiacion-privada-list',
    templateUrl: './financiacion-privada-list.component.html',
    styleUrls: ['./financiacion-privada.component.css'],
    standalone: false
})
export class FinanciacionPrivadaListComponent implements OnInit {
  currentPage = 1;
  itemsPerPage = 10;
  totalItems = 0;

  public headerTable: any[] = FinanciacionPrivadaConst.headerTable;

  public dataSource: FinanciacionPrivadaModel[] = [];

  public empty: boolean = false;
  public ready: boolean = false;
  public spinner: boolean = false;

  public download: boolean = false;
  public empty_guid = consts.EMPTY_GUID;

  constructor(
    private financiacionPrivadaService: FinanciacionPrivadaService,
    private router: Router,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    public dummy: DummyComponent,
    private tableService: TableService
  ) { }

  public ngOnInit(): void {
    this.dataSource = [];
    this.getList();
  }

  public getList() {
    this.financiacionPrivadaService.list(this.currentPage, this.itemsPerPage)
      .then(data => {
        this.tableService.set(data.list);
        this.dataSource = data.list;
        this.totalItems = data.totalItems;
        if (this.dataSource.length === 0) {
          this.empty = true;
        } else {
          this.empty = false;
        }
        this.ready = true;
      });
  }

  public pageChanged(event: any) {
    this.currentPage = event.page;
    this.getList();
  }

  public constitucion(uid: string): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    // Buscamos el obtejo de inversion y se lo pasamos al modal de pago
    const financiacionPrivadaSelected = this.dataSource.find(x => x.uid === uid);

    this.dialog.open(FinanciacionPrivadaDialogConstitucionComponent, {
      // height: '60%',
      // width: '70%',
      data: { financiacionPrivada: financiacionPrivadaSelected }
    })
      .afterClosed().subscribe(() => {
        this.dummy.redirectTo(this.router.url)
      });
  }

  public deudaACortoPlazo(uid: string): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    // Buscamos el obtejo de inversion y se lo pasamos al modal de pago
    const financiacionPrivadaSelected = this.dataSource.find(x => x.uid === uid);

    this.dialog.open(FinanciacionPrivadaDialogDeudaACortoPlazoComponent, {
      // height: '60%',
      // width: '70%',
      data: { financiacionPrivada: financiacionPrivadaSelected }
    })
      .afterClosed().subscribe(() => {
        this.dummy.redirectTo(this.router.url)
      });
  }

  public pagarCuotas(uid: string): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    // Buscamos el obtejo de inversion y se lo pasamos al modal de pago
    const financiacionPrivadaSelected = this.dataSource.find(x => x.uid === uid);

    this.dialog.open(FinanciacionPrivadaDialogPagoCuotasComponent, {
      // height: '60%',
      // width: '70%',
      data: { financiacionPrivada: financiacionPrivadaSelected }
    })
      .afterClosed().subscribe(() => {
        this.dummy.redirectTo(this.router.url)
      });
  }

  public create() {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.router.navigate([this.router.url + '/create']);
  }

  public edit(uid: string): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.router.navigate([this.router.url + '/edit' + '/' + uid]);
  }

  public delete(uid: string) {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.dialog.open(FinanciacionPrivadaDialogDeleteComponent, {
      data: { uid: uid }
    })
      .afterClosed().subscribe(result => {
        this.dummy.redirectTo(this.router.url)
      });
  }

  public uploadFileAttachment(uid: string) {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.dialog.open(FinanciacionPrivadaDialogAttachmentComponent, {
      data: { uid: uid }
    })
      .afterClosed().subscribe(result => {
        this.dummy.redirectTo(this.router.url)
      });
  }

  public downloadFileAttachment(uid: string): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.financiacionPrivadaService.downloadFileAttachment(uid).then(response => {
      FileSaver.saveAs(response, Utils.GetFileName("Fichero_Adjunto", consts.EXT_EXCEL));
    })
  }

  public displayInfo(response: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10500;
    this.snackBar.open(response, '', options);
  }

  public addManualAccountMovements(): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.dialog
      .open(AccountingManualFormComponent, {
        width: '60%',
        height: '70%',
        data: {
          accountingMovementId: ''
        }
      })
      .afterClosed().subscribe((result: string) => {
        if (!Utils.IsNullOrEmpty(result)) {
          if (result === 'OK') {
            this.dummy.redirectTo(this.router.url);
          }
        }
      });
  }

  public trackByIndex(i: number) { return i; }

}
